export enum WorkOpportunitiesTab {
  MatchingRoles = "matching_roles",
  Interested = "interested",
  SavedRoles = "saved_roles",
  SharedWithMe = "shared_with_me"
}
